import { TableCell as BaseTableCell } from '@tiptap/extension-table-cell';

export const TableCell = BaseTableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const style = element.getAttribute('style') || '';
          const match = style.match(/background-color:\s*([^;]+)/);
          return match ? match[1] : null;
        },
        renderHTML: (attributes: { backgroundColor?: string }) => {
          if (!attributes.backgroundColor) {
            return {};
          }
          return {
            style: `background-color: ${attributes.backgroundColor}`
          };
        }
      }
    };
  }
});
